import React, { Component } from 'react'
import Prismic from 'prismic-javascript'
import { PrismicConfig } from '../../../../helpers/prismicHelpers/PrismicAPI'
import { LanguagePrismicHelper } from '../../../../helpers/prismicHelpers/PrismicHelpers'
import { magazinePageHelper } from '../../../../helpers/prismicHelpers/prismic-custom-helpers/MagazinePageHelpers'
import { prismicSliceHelper, prismicSliceContentRelationship } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers'
import { sliceComponentsHelper } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers'
import Loader from '../../../common/elements/Loader'
import MagazineComponent from './MagazineComponent'

class MagazinePage extends Component {

    state = {
        slices: null,
        magazines_array: null,
        topOfMagazine: null
    }
	
    async componentDidMount() {
        //prismic
        const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, { accessToken: PrismicConfig.apiAccessTokes });
        const json = await prismicConnection.query(Prismic.Predicates.at('my.magazine-page.uid', 'magazine-page'), LanguagePrismicHelper());
        let { slices } = prismicSliceHelper(json);
        slices = (slices && slices.length) ? await prismicSliceContentRelationship(slices, prismicConnection, ) : null;
        const magazines_array = magazinePageHelper(json);
		this.setState({ slices , magazines_array })
	}
	
	componentDidUpdate() {
        const topOfMagazine = document.getElementById('current-magazine');
    	this.setState({topOfMagazine});
	}

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.slices !== nextState.slices || this.state.magazines_array !== nextState.magazines_array || this.state.topOfMagazine !== nextState.topOfMagazine
    }
    
    scrollToMagazine = () => {

        this.state.topOfMagazine.scrollIntoView({behavior: 'smooth', block: 'start'})

    }
	

    render() {
        const { slices, magazines_array } = this.state;
        if (!slices || !magazines_array) return <Loader />

        return (
            <React.Fragment>
                {sliceComponentsHelper(slices)}
                <MagazineComponent magazines_array={magazines_array} magazineTop={this.scrollToMagazine} />
            </React.Fragment>
        )
    }
}

export default MagazinePage;



// WEBPACK FOOTER //
// src/client/components/site/features/magazine/MagazinePage.js